
import { FirearmAssignablePersonEntityDecorator } from './firearm-assignable-person.decorator';
import { FirearmAssignablePerson } from './firearm-assignable-person.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmAssignablePersonTypeInfoBase implements CrudTypeInfo<FirearmAssignablePerson, string> {
  name = 'Firearm Assignable Person';
  entityDecorator = new FirearmAssignablePersonEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM_ASSIGNABLE_PERSON'];
  editAuthorities = ['WRITE_FIREARM_ASSIGNABLE_PERSON'];
  deleteAuthorities = ['WRITE_FIREARM_ASSIGNABLE_PERSON'];
  viewAuthorities = ['READ_FIREARM_ASSIGNABLE_PERSON'];
  
  searchRouteBase = ['/firearmassignableperson/search'];
  createRouteBase = ['/firearmassignableperson/create'];
  editRouteBase = ['/firearmassignableperson/edit'];
  viewRouteBase = ['/firearmassignableperson/view'];
  
  description(item: FirearmAssignablePerson): string {
    return '' +  item.personId +  ' - ' +  item.name;
  }
}



